var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScreenshare = function SvgScreenshare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 28 22",
    xmlns: "http://www.w3.org/2000/svg"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#screenshare_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.359 0A4.359 4.359 0 0 0 0 4.359V17.64A4.359 4.359 0 0 0 4.359 22H23.64A4.359 4.359 0 0 0 28 17.641V4.36A4.359 4.359 0 0 0 23.641 0H4.36ZM14.75 7.81V16 7.81Zm3.462 2.433a.75.75 0 0 0 0-1.061L14.53 5.47l3.68 3.712a.75.75 0 0 1 0 1.06ZM13.25 7.81l-2.433 2.432L13.25 7.81Zm-2.433 2.432Zm7.572-1.238a1 1 0 0 1-1.415 1.414l-1.973-2V16a1 1 0 0 1-2 0V8.414l-2.007 2.005A1 1 0 0 1 9.58 9.005l3.713-3.712a1 1 0 0 1 1.415 0l3.681 3.712Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "screenshare_svg__a",
    x: -10.897,
    y: -10.897,
    width: 49.795,
    height: 43.795,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 5.449
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8873_5845"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_8873_5845",
    result: "shape"
  })))));
};
export default SvgScreenshare;